<div *ngIf="showAlert" class="alert" [ngClass]="class" style="width: 500px;">
  {{message}}<br>
  <button type="button" class="close" (click)="showAlert = false;" style="margin-top:-20px;margin-right:10px;float: right">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
